<template>
  <div id="admin-login">
    <div class="bg-admin">
      <div class="block-admin-login">
        <div class="block-admin-form">
          <div class="text-center">
            <h2 class="mb-0 bold text-blue">RentalAgentCloud</h2>
          </div>
          <br />
          <form @submit.stop.prevent="onSubmit">
            <div class="form-group mb-4">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <i class="fas fa-envelope"></i>
                </b-input-group-prepend>
                <b-form-input
                  type="email"
                  placeholder="Email"
                  id="email"
                  name="email"
                  v-model="form.email"
                  v-validate="{ required: true, email: true }"
                  :state="validateState('email')"
                ></b-form-input>
              </b-input-group>
            </div>
            <div class="form-group">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <i class="fas fa-lock"></i>
                </b-input-group-prepend>
                <b-form-input
                  type="password"
                  placeholder="Password"
                  v-model="form.password"
                  id="password"
                  name="password"
                  v-validate="{ required: true }"
                  :state="validateState('password')"
                ></b-form-input>
              </b-input-group>
              <div id="error-msg" class="text-danger pt-1">{{ errorMsg }}</div>
            </div>
            <button
              type="submit"
              class="btn btn-primary w-100 cursor-default"
              id="submit"
            >
              <i class="fas fa-sign-in-alt"></i> Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errorMsg: "",
      form: {
        email: "",
        password: "",
      },
    };
  },
  mounted() {},
  methods: {
    validateState(ref) {
      if (
        this.$veeFields[ref] &&
        (this.$veeFields[ref].dirty || this.$veeFields[ref].validated)
      ) {
        return !this.$veeErrors.has(ref);
      }
      return null;
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        let loading = this.$loading.show();
        const formData = new FormData();
        formData.append("email", this.form.email);
        formData.append("password", this.form.password);
        this.$http
          .post(this.$app.baseURL + this.$path.userLogin, formData)
          .then(
            (res) => {
              loading.hide();
              console.log(res.data);
              console.log(res.status);
              console.log(res.data.data[0].role);
              if (res.status == 200 && res.data.data[0].role == "ADMIN") {
                localStorage.setItem(
                  "agenthub-admin",
                  JSON.stringify(res.data.data[0])
                );
                this.$router.replace("/agentclound-management");
              } else {
                localStorage.removeItem("agenthub-admin");
                this.errorMsg = "* " + res.data.message_EN;
              }
            },
            () => {
              loading.hide();
              localStorage.removeItem("agenthub-admin");
              this.errorMsg =
                "* Unable to connect to server please try again later";
            }
          );
      });
    },
  },
};
</script>

<style scoped>
.bg-admin {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 8;
  background: #f8f8f8;
}

.block-admin-login {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
}

.block-admin-form {
  width: 465px;
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
  margin: 0 auto;
  padding: 30px 70px;
  box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.1);
  -o-box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.1);
}
</style>